import { useEffect, useState } from 'react'
import socket from '../utils/socket'

export function useChatSocket(roomId, email) {
  const [messages, setMessages] = useState([])
  const [onlineUsers, setOnlineUsers] = useState([])

  useEffect(() => {
    if (!roomId || !email) return
    socket.emit('switchRoomChat', { roomId, email })
    // socket.emit('joinRoomChat', { roomId, email })

    socket.on('sendMessage', (message) => {
      setMessages((prev) => [...prev, message])
    })

    socket.on('chatHistory', (history) => {
      setMessages(history)
    })

    socket.on('onlineUsers', (users) => {
      setOnlineUsers(users)
    })

    return () => {
      // socket.emit('leave-room', { roomId, email })
      // socket.disconnect()
      // socket.emit('disconnect', { roomId, email }) //user if not working
      socket.off('sendMessage')
      socket.off('chatHistory')
      socket.off('onlineUsers')
    }
  }, [roomId, email])

  const sendMessage = (text) => {
    const message = {
      id: Math.floor(Math.random() * 1000),
      text,
      email,
      roomId,
      timestamp: new Date().toISOString(),
    }
    socket.emit('sendMessage', message)
  }

  return { messages, sendMessage, onlineUsers }
}
